import { Card, CardContent } from "@mui/material";
import { useEffect } from "react";
import { FieldValues, useFormContext } from "react-hook-form";
import { BooleanInput, TextInput } from "react-admin";
import { Stack } from "@mui/system";
import DateSubForm from "./DateSubForm";
import { TestKey } from "../types";

const CardForm = ({
  formData,
  index,
  basekey,
  test,
}: {
  formData: FieldValues;
  index: number;
  basekey: string;
  test: { key: TestKey; label: string };
}) => {
  const { getValues, setValue } = useFormContext();
  const testType = getValues("type");

  useEffect(() => {
    setValue(`${basekey}.test_name`, test.key);
  }, [testType, setValue, basekey, test]);

  return (
    <Card
      key={`${formData?.type || "fcr_n"}-${test.key}`}
      sx={{
        background: "#f7f7f7",
        minWidth: 320,
      }}
    >
      <CardContent>
        <BooleanInput source={`${basekey}.selected`} label={test.label} />
        <TextInput source={`${basekey}.test_name`} label="Test Name" readOnly defaultValue={test.key} />
        <Stack direction="column" spacing={1}>
          <DateSubForm formData={formData} index={index} basekey={basekey} />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CardForm;
